import { render, staticRenderFns } from "./DetailMaklPeribadi.vue?vue&type=template&id=a0dcf1ce&"
import script from "./DetailMaklPeribadi.vue?vue&type=script&lang=js&"
export * from "./DetailMaklPeribadi.vue?vue&type=script&lang=js&"
import style0 from "./DetailMaklPeribadi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports